import { Outlet } from 'react-router-dom';

const Layout = () => (
  <div className="min-h-full min-w-full bg-lightBlue-5 py-4">
    <div className="flex justify-center min-h-fit w-full my-8 bg-white rounded-xl shadow-md max-w-5xl mx-auto">
      <Outlet />
    </div>
  </div>
);

export default Layout;
